import { render, staticRenderFns } from "./GenreDropdown.vue?vue&type=template&id=2a276722&scoped=true&"
import script from "./GenreDropdown.vue?vue&type=script&lang=js&"
export * from "./GenreDropdown.vue?vue&type=script&lang=js&"
import style0 from "./GenreDropdown.vue?vue&type=style&index=0&id=2a276722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a276722",
  null
  
)

export default component.exports